import axios from 'axios';
import * as Url from '../api/url';
// TODO: Make functional + use TaskEither
export const requestConfigurationCode = async (serviceUrls, data) => {
    return await axios.post(Url.toString({ base: serviceUrls.layouts, path: '/configurations', query: {} }), JSON.parse(JSON.stringify(data)));
};
// TODO: Make functional + use TaskEither
export const requestShortLinkCode = async (serviceUrls, data) => {
    const url = Url.toString({ base: serviceUrls.links.service, path: '/links', query: {} });
    return await axios.post(url, JSON.parse(JSON.stringify(data)));
};
